// The help drawer and the guided walkthroughs: which is open, and what this
// browser remembers about walkthroughs. Not Curator API data, so not actions.ts.

import { getState, setState } from "./store.ts";

export type TourId = "studio" | "overview" | "demand" | "pricing";
export const TOUR_IDS: ReadonlyArray<TourId> = ["studio", "overview", "demand", "pricing"];

const TOURS_ON = "studio-walkthroughs-on";
const SEEN = "studio-walkthroughs-seen";

/** Walkthroughs are off until this browser turns them on. */
export function storedToursOn(): boolean {
  try { return localStorage.getItem(TOURS_ON) !== null; } catch { return false; }
}

/** The walkthroughs this browser finished or skipped, so they aren't offered again. */
export function storedSeen(): TourId[] {
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(SEEN) ?? "[]");
    return Array.isArray(saved) ? TOUR_IDS.filter((id) => saved.includes(id)) : [];
  } catch {
    return [];
  }
}

function save(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // Storage is blocked: the setting lasts for this visit.
  }
}

export const openHelp = () => setState({ helpOpen: true, tour: null });
export const closeHelp = () => setState({ helpOpen: false });

export const startTour = (id: TourId) => setState({ tour: { id, step: 0 }, helpOpen: false });
export const stepTour = (step: number) => setState((s) => (s.tour ? { tour: { ...s.tour, step } } : {}));

/** Ends the walkthrough that's running; finished or skipped, it isn't offered again. */
export function endTour() {
  const { tour, seenTours } = getState();
  if (!tour) return;
  const seen = seenTours.includes(tour.id) ? seenTours : [...seenTours, tour.id];
  save(SEEN, JSON.stringify(seen));
  setState({ tour: null, seenTours: seen });
}

export function setToursOn(on: boolean) {
  save(TOURS_ON, on ? "1" : null);
  setState((s) => ({ toursOn: on, tour: on ? s.tour : null }));
}
